import React from "react";
import Lottie from "react-lottie";
import * as HappyBirthdayText from "./HappyBirthdayText.json";

export default function HappyBirthdayTextComp() {
  const buttonStyle = {
    display: "block",
    margin: "10px auto",
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: HappyBirthdayText,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Lottie options={defaultOptions} height={"8.375em"} width={"14em"} />
  );
}
